import { render, staticRenderFns } from "./a-add-to-cart.vue?vue&type=template&id=edbd1336&"
import script from "./a-add-to-cart.vue?vue&type=script&lang=js&"
export * from "./a-add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports